/**
 * LeftShield Portal - 404 Not Found Page
 * Shown when a user navigates to a route that does not exist.
 */
import React from 'react';
import {
  Title1,
  Body1,
  Button,
  tokens,
} from '@fluentui/react-components';
import {
  SearchRegular,
  HomeRegular,
  ArrowLeftRegular,
} from '@fluentui/react-icons';
import { useNavigate } from 'react-router-dom';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4rem 2rem',
        textAlign: 'center',
        minHeight: '60vh',
      }}
    >
      <SearchRegular
        style={{
          fontSize: '4rem',
          color: tokens.colorNeutralForeground3,
          marginBottom: '1.5rem',
        }}
      />
      <Title1 style={{ marginBottom: '0.75rem' }}>Page Not Found</Title1>
      <Body1
        style={{
          color: tokens.colorNeutralForeground3,
          maxWidth: '400px',
          marginBottom: '2rem',
        }}
      >
        The page you requested does not exist or you may not have access.
        Check the URL or navigate back to the dashboard.
      </Body1>
      <div style={{ display: 'flex', gap: '0.75rem' }}>
        <Button
          appearance="secondary"
          icon={<ArrowLeftRegular />}
          onClick={() => navigate(-1)}
        >
          Go Back
        </Button>
        <Button
          appearance="primary"
          icon={<HomeRegular />}
          onClick={() => navigate('/')}
        >
          Dashboard
        </Button>
      </div>
    </div>
  );
};
